import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, LOGOUTAtive } from "../../redux/slices/auth";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import WalletIcon from "@mui/icons-material/Wallet";
import { FilterTiltShift } from "@material-ui/icons";

// import introJs from "intro.js";
// import "intro.js/introjs.css";

const Leftsidebar = () => {
  const [activeLink, setActiveLink] = useState("");
  const { user } = useSelector((value) => value.login);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Function to handle logout
  const handleLogout = () => {
    // dispatch(logout());
    dispatch(LOGOUTAtive(navigate));
    // navigate("/login");
  };

  // useEffect(() => {
  //   const isDesktop = window.innerWidth > 768;

  //   const tourStart = () => {
  //     introJs()
  //       .setOptions({
  //         steps: [
  //           {
  //             element: "#sidebar-dashboard",
  //             intro: "This is your Dashboard where you can monitor activity.",
  //           },
  //           {
  //             element: "#sidebar-wallet",
  //             intro: "Click here to deposit or manage your wallet.",
  //           },
  //           {
  //             element: "#sidebar-cashout",
  //             intro: "You can withdraw your winnings from here.",
  //           },
  //           {
  //             element: "#sidebar-history",
  //             intro: "Track your game and payment history here.",
  //           },
  //           {
  //             element: "#sidebar-profile",
  //             intro: "View and update your profile here.",
  //           },
  //           {
  //             element: "#sidebar-logout",
  //             intro: "Click here to log out of your account securely.",
  //           },
  //         ],
  //         tooltipPosition: "right",
  //         scrollToElement: true,
  //         showBullets: false,
  //         nextLabel: "",
  //         prevLabel: "",
  //         doneLabel: "",
  //         skipLabel: "",
  //         highlightClass: "custom-highlight",
  //       })
  //       .oncomplete(() => {
  //         localStorage.setItem("sidebarTourDone", "true");
  //       })
  //       .start();
  //   };

  //   if (isDesktop && user && !localStorage.getItem("sidebarTourDone")) {
  //     // Delay until DOM has fully rendered
  //     setTimeout(tourStart, 500); // you can tweak 500ms if needed
  //   }
  // }, [user]);

  return (
    <aside className="lg:w-52 space-y-6 flex-shrink-0 hidden lg:block">
      <div
        className="py-4  rounded-lg custom-border items-center fixed 
               h-auto max-h-[85vh] overflow-x-hidden
               scrollbar-thin scrollbar-thumb-[#c246a5] scrollbar-track-gray-300"
        style={{ width: "220px", minHeight: "300px" }}
      >
        <div className="overflow-hidden flex justify-center items-center mb-3">
          <img
            src={user?.image ? user?.image : "/images/user.png"}
            alt="User Avatar"
            className="object-cover w-20 h-20 rounded-full"
          />
        </div>

        <span className="text-white font-semibold mb-4 text-center w-full">
          {user?.name}
        </span>

        {[
          {
            label: "Dashboard",
            icon: <DashboardOutlinedIcon />,
            url: "/dashboard",
            id: "sidebar-dashboard",
          },
          {
            label: "Wallet",
            icon: <WalletIcon />,
            url: "/Wallet",
            id: "sidebar-wallet",
          },
          {
            label: "Cashout",
            icon: <PaymentsOutlinedIcon />,
            url: "/cashout",
            id: "sidebar-cashout",
          },
          {
            label: "History",
            icon: <HistoryOutlinedIcon />,
            url: "/history",
            id: "sidebar-history",
          },
          {
            label: "Profile",
            icon: <AccountCircleOutlinedIcon />,
            url: "/Profile",
            id: "sidebar-profile",
          },
          {
            label: "Spin a Wheel",
            icon: <FilterTiltShift />,
            url: "/spin-a-wheel",
            id: "sidebar-wheel",
          },
        ].map((item) => (
          <Link
            to={item.url}
            id={item.id}
            key={item.label}
            onClick={() => setActiveLink(item.label)}
            className={`flex items-center gap-3 px-4 py-3 transition-all duration-300 text-white ${
              activeLink === item.label
                ? "bg-gradient-to-b from-[#601352] via-[#b4006f] to-[#641254]"
                : "hover:bg-gradient-to-b from-[#601352] via-[#b4006f] to-[#641254]"
            } transform hover:scale-105`}
          >
            {item.icon}
            <span className="font-semibold text-sm">{item.label}</span>
          </Link>
        ))}

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="w-full flex items-center gap-3 px-4 py-3 transition-all duration-300 text-white hover:bg-gradient-to-b from-[#601352] via-[#b4006f] to-[#641254] transform hover:scale-105"
        >
          <PowerSettingsNewOutlinedIcon />
          <span className="font-semibold text-sm " id="sidebar-logout">
            Logout
          </span>
        </button>
      </div>
    </aside>
  );
};

export default Leftsidebar;
